import styled from '@emotion/styled';

export const SSearchInput = styled.input`
  width: 100%;
  height: 66px;
  display: block;
  border: none;
  padding: 16px 21px;
  outline: none;
`;
